import type { ReactNode } from 'react';

export interface FormFieldProps {
  label: string;
  hint?: string;
  error?: string;
  children: ReactNode;
}

export function FormField({ label, hint, error, children }: FormFieldProps) {
  return (
    <label className="form-field">
      <div className="form-field__label">{label}</div>
      <div className="form-field__control">{children}</div>
      {error ? <div className="form-field__error">{error}</div> : null}
      {!error && hint ? <div className="form-field__hint">{hint}</div> : null}
    </label>
  );
}
